import { FC } from 'react';
import { useNavigate } from 'react-router';
import TopNav from './TopNav';
import Logo from './Logo';

interface BasicTopNavProps {
  withLogo?: React.ReactNode;
}

const BasicTopNav: FC<BasicTopNavProps> = ({ withLogo }) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/');
  };

  return (
    <TopNav
      left={
        <div className='flex w-full items-center justify-center px-8 md:px-20 lg:justify-start'>
          {withLogo ? (
            withLogo
          ) : (
            <button
              type='button'
              className='block py-2 outline-none focus:outline-none'
              onClick={handleOnClick}
            >
              <Logo />
            </button>
          )}
        </div>
      }
    ></TopNav>
  );
};

export default BasicTopNav;
